import { createTheme } from "@mui/material/styles"
import { sharedTheme } from "ui"
import colors from "./colors"
const customTheme = createTheme({
  ...sharedTheme,
  components: {
    ...sharedTheme.components,
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          height: "48px",
          "&:focus-visible": {
            border: `2px dashed white`,
            outlineOffset: "2px",
            outline: "3px dashed #10059f",
          },
        },
        sizeLarge: {
          fontSize: "18px",
          lineHeight: "22px",
          padding: "13px 23px",
        },
        sizeSmall: {
          minWidth: "153px",
          fontSize: "16px",
          lineHeight: "20px",
          padding: "8px 16px",
        },
      },
      variants: [
        {
          props: { variant: "contained" },
          style: {
            borderRadius: "200px",
          },
        },
        {
          props: { variant: "text" },
          style: {
            textDecoration: "underline",
            textDecorationThickness: "1px",
            backgroundColor: "transparent",
            color: "#000",
            "&:hover": {
              textDecoration: "underline",
              background: "transparent",
            },
            "&:active": {
              color: "#6F6F6F",
              textDecoration: "underline",
              textDecorationThickness: "2px",
            },
            "&:disabled": {
              textDecoration: "none",
              color: "#6F6F6F",
            },
          },
        },
        {
          props: { variant: "outlined" },
          style: {
            border: `2px solid ${colors.buttonDefaultBackgroundColor}`,
            backgroundColor: colors.buttonDefaultBackgroundColor,
            color: colors.buttonHoverTextColor,

            borderRadius: "200px",
            "&:hover": {
              border: `2px solid ${colors.buttonHoverBackgroundColor}`,
              backgroundColor: colors.buttonHoverBackgroundColor,
              boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.16)",
              color: colors.buttonHoverTextColor,
            },

            "&:active,&:focus-visible": {
              backgroundColor: colors.buttonActiveBackgroundColor,
              border: `2px solid ${colors.buttonActiveBackgroundColor}`,
            },
            "&:disabled": {
              border: `2px solid ${colors.buttonDisabledBackgroundColor}`,
              color: colors.buttonHoverTextColor,
              backgroundColor: colors.buttonDisabledBackgroundColor,
            },
          },
        },
      ],
    },
  },
})

export const theme = {
  ...customTheme,
  colors,
}

export type Theme = typeof theme
